export default __webpack_public_path__ + "static/media/artistLogo2.1038623a.png";